<template>
  <g >
    <g v-for="rect of productSVGData()" :key="rect.id">
      <!-- <g v-show="appIdsToShow.includes(rect.id)" v-for="row of rect.rows" :key="row.id">
        <text :x="rect.x" :y="0" >{{row.product}}</text>
      </g>  -->
      <rect :id="rect.id" style="cursor: pointer;" :x="rect.x" :y="0" :width="rect.size" :height="rect.size" :style="rect.style" />  
      <b-popover :target="rect.id" triggers="hover" placement="top" >
        <template #title>{{rect.title}}</template>
        {{rect.string}}
      </b-popover>
    </g>   
  </g>
</template>

<script>

import { line, scaleTime, scaleLinear } from "d3";
import { mapGetters } from "vuex";
import { randomId } from "../modules/utils";

export default {
  name: "product-graph",
  props: {
    rowHeight: {
      type: Number,
      default: 200
    }, 
    windowWidth: {
      type: Number,
      default: 500
    },
    uniqueDates: Array,
    row: Object
  },
  data() {
    return {
      
    };
  },
  methods: {
      
    createScales(data) {
      const dates = this.uniqueDates;
      const x = scaleTime().domain([ Math.min(...dates), Math.max(...dates) ]).range([160, this.windowWidth - 40]);
      let values = data.map(x => parseFloat(x.value));

      const y = scaleLinear().domain( [ Math.max(...values), Math.min(...values) ] ).range([10, this.rowHeight - 20]);
      return {x, y};
    },
    productSVGData() {
      const tabs = this.currentDataSets.filter(x => x.tabData);
      
      const {x, y} = this.createScales([0, 100]);
            
      const appsToDraw = [];
      for (let row of tabs) {
        let style = {fill: row.color};
        let apps = row.tabData.categories || row.tabData.applications;

        const currentSet = this.allActiveSetData.find(x => x.id === row.id);
        if (!currentSet) {
          continue;
        } 
        const dates = Array.from(new Set(currentSet.data.map(x => x.sampleDate))).map(x => new Date(x));
        let minDate = Math.min(...dates);
        let maxDate = Math.max(...dates);
        apps = apps.filter(x => {
          let d = new Date(x.startDate || x.appDate);
          return d > minDate && d < maxDate;
        });

        for (let app of apps) {
          let string = "";
          for (let r of app.rows) {
            string += `${r.rate} ${r.rateSize} ${r.product}, `;
          }
          let timeMs = 0;
          let dateMs = (new Date(app.startDate || app.appDate)).getTime();
          if (app.apps > 1) {
            if (app.interval) {
              let splitInterval = app.interval.split(" ");
              let numTime = parseInt(splitInterval[0]);
              if (splitInterval[1] == "day" || splitInterval[1] == "days") {
                timeMs = 86400000 * numTime;
              } else if (splitInterval[1] == "week" || splitInterval[1] == "weeks") {
                timeMs = 604800000 * numTime;
              } else if (splitInterval[1] == "month" || splitInterval[1] == "months") {
                timeMs = 2629800000 * numTime;
              }
            }

            for (let i = 0; i < app.apps; i++) {
              let date = new Date(dateMs);

              appsToDraw.push({
                id: randomId(),
                x: x(date),
                style,
                size: 15,
                show: app.show,
                title: app.title,
                string
              });
              dateMs += timeMs;
            }
          } else {
            appsToDraw.push({
              id: randomId(),
              x: x(new Date(app.startDate || app.appDate)),
              style,
              size: 15,
              show: app.show,
              title: app.title,
              string
            });
          }
        }
      }
      return appsToDraw;
    }
  },
  computed: {
    ...mapGetters(["allActiveSetData", "currentDataSets"])
  }
};
</script>

<style lang="scss" scoped>

</style>